import useDateTimeFormat from 'lib/hooks/useDateTimeFormat';

import Avatar from 'components/shared/Avatar/Avatar';
import Icon from 'components/shared/Icon/Icon';
import Input from 'components/shared/Input/Input';
import Loader from 'components/shared/Loader/Loader';
import RadioButton from 'components/shared/RadioButton/RadioButton';

const PatientPicker = ({
  filters,
  setFilters,
  selectedPatient,
  setSelectedPatient,
  allPatients,
  isFetching,
  divRef,
  handleScroll
}) => {
  const { formatDate } = useDateTimeFormat();
  return (
    <>
      <Input
        id="searchPatient"
        type="string"
        placeholder="Search patient..."
        value={filters.search}
        rounded="full"
        icon="search-linear"
        className="!border-secondary-400 !mr-5 !rounded-2xl"
        onChange={(e) => setFilters((prev) => ({ ...prev, search: e.target.value }))}
        rightText={
          filters.search && (
            <Icon
              icon="close-linear"
              onClick={() => setFilters((prev) => ({ ...prev, search: '' }))}
            />
          )
        }
      />
      <div
        className="!mt-4 flex max-h-[calc(100vh-290px)] flex-col !gap-4 overflow-y-auto"
        ref={divRef}
        onScroll={handleScroll}>
        {allPatients?.map((patient) => (
          <div
            key={patient?.id}
            onClick={() => setSelectedPatient(patient)}
            className="flex cursor-pointer items-center gap-3 ">
            <div className="ml-[2px] flex w-[25px]">
              <RadioButton
                value={true}
                id={patient.id}
                name="selectedPatient"
                isSelected={selectedPatient?.id === patient.id}
              />
            </div>
            <Avatar
              firstName={patient?.f_name}
              lastName={patient?.l_name}
              id={patient?.id}
              size="xl"
            />
            <div className="flex flex-col">
              <h3 className="text-base font-500 text-neutral-900">{patient?.fullName}</h3>
              {patient?.dob && (
                <div className="text-xs text-neutral-500">{formatDate(patient.dob)}</div>
              )}
            </div>
          </div>
        ))}

        {isFetching && (
          <div className="flex items-center justify-center">
            <Loader />
          </div>
        )}
      </div>
    </>
  );
};

export default PatientPicker;
